export const MANY = 1;
export const FEW = 2;
export const MANY_SOON = 3;
export const NOT_AVAILABLE = 4;
